<!-- DIALOG -->
@if (tile) {
    <p-dialog
        [(visible)]="showDialog"
        [modal]="true"
        [draggable]="false"
        [resizable]="false"
        (onHide)="closeDialog()"
        [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
        [style]="{ width: '550px' }"
    >
        <ng-template pTemplate="header">
            <div class="flex items-center justify-between gap-12">
                <span class="p-dialog-title">{{ (isAddCase ? "tiles_add" : "tiles_edit") | translate: { layerName } }}</span>
            </div>
        </ng-template>

        <div class="p-fluid mt-2" style="overflow: visible">
            <div class="dialog-first-row">
                <p-floatlabel class="w-full" style="overflow: visible">
                    <!-- eslint-disable @html-eslint/no-duplicate-id -->
                    @if (tile.externalRefs) {
                        <input
                            class="w-[calc(100%-30px)]"
                            [ngClass]="{ 'border-red-500!': nameInvalid }"
                            [disabled]="isTileArchived"
                            id="float-input1"
                            type="text"
                            pInputText
                            [(ngModel)]="tile!.name"
                            autofocus
                            (ngModelChange)="checkNameValidity($event)"
                        />
                        <app-external-refs [externalRefs]="tile.externalRefs" />
                    } @else {
                        <input
                            class="w-full"
                            [ngClass]="{ 'border-red-500!': nameInvalid }"
                            [disabled]="isTileArchived"
                            id="float-input1"
                            type="text"
                            pInputText
                            [(ngModel)]="tile!.name"
                            autofocus
                            (ngModelChange)="checkNameValidity($event)"
                        />
                    }
                    <label for="float-input1">{{ "tiles_name" | translate }}</label>
                </p-floatlabel>
                <div class="ml-4 mr-4">
                    <div style="display: inline-block">
                        <button
                            data-testid="tile-favorite"
                            [attr.aria-label]="(tile.favorite ? 'tiles_remove_favorite_label' : 'tiles_add_favorite_label') | translate"
                            [disabled]="isTileArchived"
                            pButton
                            pRipple
                            type="button"
                            (click)="toggleFavorite()"
                            icon="{{ tile.favorite ? 'pi pi-star-fill' : 'pi pi-star' }}"
                            class="p-button-rounded p-button-text"
                        ></button>
                    </div>
                </div>
                <button
                    data-testid="tile-color"
                    [attr.aria-label]="'tiles_color' | translate"
                    [disabled]="isTileArchived"
                    type="button"
                    pButton
                    (click)="color.toggle($event)"
                    class="color-select-button p-button-rounded p-button-text"
                    [ngStyle]="setCustomColorpickerStyle()"
                >
                    &nbsp;
                </button>
                <p-popover #color (onShow)="initializeColorPickerAndInput()" styleClass="tiles-color-popover-fix">
                    <ng-template pTemplate="content">
                        @for (_color of colors; track $index; let i = $index) {
                            @if (i % 4 === 0) {
                                <div class="flex">
                                    @for (c of colors.slice(i, i + 4); track c) {
                                        <div class="m-2">
                                            <button
                                                [attr.data-color]="c"
                                                pButton
                                                type="button"
                                                class="p-button-rounded"
                                                icon="pi pi-check"
                                                [style.background-color]="c"
                                                [style.border-color]="c"
                                                [style.color]="c"
                                                (click)="changeColor(c)"
                                            ></button>
                                        </div>
                                    }
                                </div>
                            }
                        }
                        <div class="flex flex-col items-center mt-2">
                            <button type="button" pButton class="p-button-text" pStyleClass="@next" toggleClass="hidden" enterActiveClass="my-fadein">
                                {{ "tiles_more_colors" | translate }}
                            </button>
                            <div class="flex mt-4 hidden">
                                <div class="box">
                                    <form [formGroup]="colorForm" (ngSubmit)="onSubmit(color)" class="flex flex-row justify-center">
                                        <p-colorPicker
                                            formControlName="color"
                                            inputId="cp-hex"
                                            class="mt-1"
                                            (onChange)="onCustomColorChange($event)"
                                        ></p-colorPicker>
                                        <input
                                            type="text"
                                            pInputText
                                            formControlName="color"
                                            style="width: 10.8rem"
                                            class="ml-2"
                                            placeholder="#FFFFFF"
                                            [ngClass]="{ 'ng-invalid': isInvalidColor }"
                                            (input)="onColorInput($event)"
                                        />
                                    </form>
                                    @if (isInvalidColor()) {
                                        <small class="p-error mt-2" style="max-width: 13rem; word-wrap: break-word; white-space: normal; display: block">
                                            {{ "hex_code_error" | translate }}
                                        </small>
                                    }
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </p-popover>
            </div>

            <!-- Description -->
            <p-floatlabel class="mt-8">
                <input class="w-full" [disabled]="isTileArchived" id="float-input2" type="text" pInputText [(ngModel)]="tile!.description" />
                <label for="float-input2">{{ "tiles_description" | translate }}</label>
            </p-floatlabel>

            <!-- Parent siwtch -->
            @if (layerIndex !== 1) {
                <div class="flex items-center justify-between mt-6 mb-2">
                    <label class="mb-0">{{ "tile_parent_name_label" | translate: { parentLayerName: parentLayerName } }}</label>
                    <div class="flex items-center">
                        <i class="pi pi-globe mr-2" style="font-size: 1.3rem" [style.color]="isGlobal() ? '#6c757d' : '#6c757d'"></i>
                        <span
                            class="mr-2"
                            style="color: #6c757d"
                            pTooltip="{{ 'tiles_assigntoall' | translate: { parentLayerName: parentLayerName } }}"
                            tooltipPosition="top"
                        >
                            {{ "tile_parent_global_toggle_label" | translate: { parentLayerName: parentLayerName } }}
                        </span>
                        <div
                            pTooltip="{{ 'tiles_assigntoall_proFeature' | translate: { parentLayerName: parentLayerName } }}"
                            [tooltipDisabled]="isPro"
                            style="display: flex; justify-content: center; align-items: center; transform: scale(0.85) translateY(10%)"
                        >
                            <p-toggleswitch
                                data-testid="tile-global"
                                id="globalCb"
                                #checkboxes
                                [ngModel]="isGlobal()"
                                inputId="binary"
                                (onChange)="changeGlobal()"
                                [disabled]="!isPro || isTileArchived"
                            />
                        </div>
                    </div>
                </div>
                <!-- Parent options -->
                @if (!isGlobal() && tileParents.length > 0) {
                    <p-multiSelect
                        data-testid="tile-parents"
                        [disabled]="isTileArchived"
                        [options]="tileParents"
                        [ngModel]="tile!.parents"
                        (ngModelChange)="changeParents($event)"
                        optionLabel="name"
                        display="chip"
                        inputId="tileSelection"
                        class="w-full"
                        [placeholder]="'tiles_selecttile' | translate: { parentLayerName: parentLayerName }"
                        appendTo="body"
                        selectedItemsLabel="{0} {{ 'standard_items_selected' | translate }}"
                    />
                } @else if (!isGlobal() && tileParents.length === 0) {
                    <p-message severity="info">
                        {{ "tiles_parent_tile_needed" | translate: { parentLayerName: parentLayerName } }}
                    </p-message>
                }
            }

            <!-- Public/private / Assignees Switch -->
            @if (teamMembers.length > 1) {
                <div class="flex items-center justify-between mt-6 mb-2">
                    <div class="flex items-center">
                        <label class="mb-0">{{ "tile_assignees_label" | translate }}</label>
                        <i class="pi pi-info-circle ml-2" pTooltip="{{ 'tile_assignment_info_label' | translate }}"></i>
                        <!-- <p-tag value="Beta" class="ml-2" pTooltip="{{ 'beta_feature' | translate }}">
                    </p-tag> -->
                    </div>
                    <div class="flex items-center">
                        <i class="pi pi-users mr-2" style="font-size: 1.4rem" [style.color]="isAssignedToAllUsers ? '#6c757d' : '#6c757d'"></i>
                        <span class="mr-2" pTooltip="{{ 'tile_public_description' | translate }}" tooltipPosition="top" style="color: #6c757d">
                            {{ "tile_public_toggle_label" | translate }}
                        </span>
                        <div
                            pTooltip="{{ 'upgrade_to_pro_for_assignments' | translate }}"
                            [tooltipDisabled]="!isPublicSwitchDisabled()"
                            style="display: flex; justify-content: center; align-items: center; transform: scale(0.85) translateY(10%)"
                        >
                            <p-toggleswitch
                                data-testid="tile-public"
                                [disabled]="isPublicSwitchDisabled() || isTileArchived"
                                [(ngModel)]="isAssignedToAllUsers"
                            />
                        </div>
                    </div>
                </div>
            }
            <!-- User/group assignment -->
            @if (!isAssignedToAllUsers && teamMembers.length > 1) {
                <p-multiSelect
                    data-testid="tile-assignees"
                    id="multiSelect"
                    [options]="assignmentOptions"
                    [group]="true"
                    [(ngModel)]="selectedAssignments"
                    placeholder="{{ 'no_member_selection' | translate }}"
                    scrollHeight="250px"
                    display="chip"
                    [disabled]="!isPro || isTileArchived"
                    pTooltip="{{ 'upgrade_to_pro_for_assignments' | translate }}"
                    [tooltipDisabled]="isPro"
                    class="w-full"
                    selectedItemsLabel="{0} {{ 'standard_items_selected' | translate }}"
                >
                    <ng-template let-group pTemplate="group">
                        @if (group.value === "groups" && group.items.length > 0) {
                            <span class="group-label">{{ group.label }}</span>
                        }
                        @if (group.value === "members" && group.items.length > 0) {
                            <span class="group-label">{{ group.label }}</span>
                        }
                    </ng-template>
                </p-multiSelect>
            }

            <!-- Time budget -->
            @if (isTimeBudgetVisible()) {
                <div class="flex items-center justify-between mt-6 mb-2">
                    <label class="mb-0" for="time-budget-enabled">{{ "time_budget_label" | translate }}</label>
                    <div class="time-budget-controls flex items-center gap-2">
                        @if (timeBudgetEnabled && isTimeBudgetAllowed()) {
                            <p-inputNumber
                                data-testid="tile-time-budget-hours"
                                inputId="time-budget-hours"
                                [(ngModel)]="timeBudgetHours"
                                mode="decimal"
                                [minFractionDigits]="0"
                                [maxFractionDigits]="timeBudgetFractionDigits"
                                [locale]="getTimeBudgetLocale()"
                                [min]="0"
                                [max]="maxTimeBudgetHours"
                                [disabled]="isTimeBudgetDisabled()"
                                [ariaLabel]="'time_budget_hours_label' | translate"
                                [inputStyleClass]="isTimeBudgetHoursMarkedInvalid() ? 'w-24 text-right border-red-500!' : 'w-24 text-right'"
                            />
                            <span class="text-muted-color">h</span>
                        } @else {
                            <span style="color: #6c757d">{{ "time_budget_none" | translate }}</span>
                        }
                        <!-- the tooltip sits on the wrapper: a disabled switch doesn't receive the pointer -->
                        @let timeBudgetTooltip = getTimeBudgetTooltip();
                        <div
                            class="dialog-toggle"
                            [pTooltip]="timeBudgetTooltip ? (timeBudgetTooltip | translate: { tileName: tile!.name.trim() || layerName, parentLayerName: parentLayerName }) : ''"
                            [tooltipDisabled]="!timeBudgetTooltip"
                            tooltipPosition="top"
                        >
                            <p-toggleswitch
                                data-testid="tile-time-budget"
                                inputId="time-budget-enabled"
                                [ngModel]="timeBudgetEnabled && isTimeBudgetAllowed()"
                                (ngModelChange)="timeBudgetEnabled = $event"
                                [disabled]="isTimeBudgetDisabled() || !isTimeBudgetAllowed()"
                            />
                        </div>
                    </div>
                </div>
                @if (isTimeBudgetSwitchedOffOnSave()) {
                    <p-message severity="warn" class="mt-2" styleClass="time-budget-switched-off">
                        {{ "time_budget_switched_off_on_save" | translate }}
                    </p-message>
                }
                @if (timeBudgetLoadFailed) {
                    <small class="block text-red-500">{{ "time_budget_load_failed" | translate }}</small>
                }
                @if (timeBudgetConflict) {
                    <p-message severity="warn" class="mt-2">{{ "time_budget_conflict" | translate }}</p-message>
                }
            }
        </div>

        <ng-template pTemplate="footer">
            <div class="flex justify-between w-full">
                <div>
                    @if (!isAddCase) {
                        <!-- Dynamic Button: Archive OR Delete -->
                        @if (!isTileArchived) {
                            <button
                                data-testid="archive-tile"
                                type="button"
                                pButton
                                severity="secondary"
                                (click)="onSingleTileArchiveOrRestore()"
                                class="p-button-text"
                            >
                                <i class="pi pi-inbox"></i>
                                {{ getArchiveButtonLabel() }}
                            </button>
                        }

                        @if (isTileArchived) {
                            <button
                                data-testid="delete-tile"
                                type="button"
                                pButton
                                severity="danger"
                                (click)="tileHasActivities ? null : deleteTileConfirm()"
                                class="p-button-text"
                                [loading]="loading"
                                [disabled]="tileHasActivities"
                                [pTooltip]="tileHasActivities ? ('tile_deletion_block' | translate: { tileName: tile.name }) : null"
                                tooltipPosition="top"
                            >
                                <i class="pi pi-trash"></i>
                                {{ "button_delete" | translate }}
                            </button>
                        }
                    }
                </div>

                <div>
                    <button
                        data-testid="cancel-tile"
                        type="button"
                        pButton
                        severity="secondary"
                        (click)="closeDialog()"
                        [disabled]="loading"
                        class="p-button-text mr-2"
                    >
                        {{ "button_cancel" | translate }}
                    </button>
                    <button
                        data-testid="save-tile"
                        type="button"
                        pButton
                        [loading]="loading"
                        (click)="isTileArchived ? onSingleTileArchiveOrRestore() : saveClicked()"
                        iconPos="left"
                        [disabled]="isTileArchived ? false : isSaveDisabled()"
                    >
                        <i [class]="isTileArchived ? 'pi pi-inbox' : 'pi pi-save'"></i>
                        {{ isTileArchived ? getArchiveButtonLabel() : ("button_save" | translate) }}
                    </button>
                </div>
            </div>
        </ng-template>
    </p-dialog>
}
